export interface INavigationRoute {
  name: string;
  displayName: string;
  meta: { icon: string };
  children?: INavigationRoute[];
}

export default {
  root: {
    name: "/",
    displayName: "navigationRoutes.home",
  },
  routes: [
    {
      name: "dashboard",
      displayName: "Dashboard",
      meta: {
        icon: "vuestic-iconset-dashboard",
      },
    },
    {
      name: "passes",
      displayName: "Fastlane and Lounge Passes",
      meta: {
        icon: "airplane_ticket",
      },
    },
    {
      name: "users",
      displayName: "Users",
      meta: {
        icon: "groups",
      },
    },
    {
      name: "magic-links",
      displayName: "Magic Links",
      meta: {
        icon: "link",
      },
      children: [
        {
          name: "bundles",
          displayName: "Bundles",
          meta: {
            icon: "inventory_2",
          },
        },
        {
          name: "magic-links",
          displayName: "Magic Links Overview",
          meta: {
            icon: "link",
          },
        },
      ],
    },
    {
      name: "product-qr",
      displayName: "Product QR",
      meta: {
        icon: "qr_code",
      },
      children: [
        {
          name: "product-qr-bundles",
          displayName: "Bundles",
          meta: {
            icon: "link",
          },
        },
      ],
    },
    {
      name: "logs",
      displayName: "Logs",
      meta: {
        icon: "description",
      },
    },
  ] as INavigationRoute[],
};
